export default __webpack_public_path__ + "static/media/omoda-ultralight.ba11b657.ttf";